import RouterData from "./Routes";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <>
      <RouterData />
      <ToastContainer />
    </>
  );
};

export default App;
